import React, { useEffect } from "react";
import cloudStore from "../../../store/CloudStore";
import { getOppMasterMerchants, getOppMerchants, updateOppMerchant } from "./OppApi";
import { Autocomplete } from "@material-ui/lab";
import { CircularProgress, Grid, MenuItem, Paper, Select, TextField, Typography } from "@material-ui/core";
import AuthorizationWrapper from "../../AuthorizationWrapper";
import withIntl from "../../../utils/withIntl";
import EditPriceTextField from "../../EditArticle/EditPriceTextField";

const locales = ["nl", "en", "fr"];

function Opp(props) {
  const [oppMerchant, setOppMerchant] = React.useState(cloudStore.merchant.opp_merchant);
  const [oppMasterMerchant, setOppMasterMerchant] = React.useState(null);
  const [oppMasterMerchants, setOppMasterMerchants] = React.useState(null);
  const [availableOppMerchants, setAvailableOppMerchants] = React.useState(null);
  const [open, setOpen] = React.useState(false);
  const [searchValue, setSearchValue] = React.useState("");
  const [options, setOptions] = React.useState([]);
  const [selectedOption, setSelectedOption] = React.useState(null);

  const [partnerFee, setPartnerFee] = React.useState(0);
  const [locale, setLocale] = React.useState("nl");

  let loading = open && options.length === 0;

  useEffect(() => {
    getOppMasterMerchants().then((oppMasterMerchants) => {
      setOppMasterMerchants(oppMasterMerchants);
    });
  }, []);

  useEffect(() => {
    if (oppMasterMerchant) {
      getOppMerchants(oppMasterMerchant.id, 1).then((oppMerchants) => {
        setAvailableOppMerchants(oppMerchants);
      });
    }
  }, [oppMasterMerchant]);

  const searchAvailableOppMerchants = (searchValue) => {
    if (!availableOppMerchants) {
      return [];
    }
    if (oppMerchant && searchValue.length === 0) {
      let oppMerchantTemp = availableOppMerchants.find(
        (availableOppMerchant) => availableOppMerchant.uid === oppMerchant.ext_merchant_key
      );
      if (oppMerchantTemp && selectedOption == null) {
        setSelectedOption(oppMerchantTemp);
      }
    }
    return availableOppMerchants.reduce((merchants, merchant) => {
      if (merchants.length > 9) {
        return merchants;
      }
      let searchValues = searchValue.split(/\s/);

      if (
        searchValues.every((value) => {
          if (value.length === 0) {
            return true;
          }
          if (
            merchant.uid?.toLowerCase().includes(value.toLowerCase()) ||
            merchant.name?.toLowerCase().includes(value.toLowerCase())
          ) {
            return true;
          }
          return false;
        })
      ) {
        merchants.push(merchant);
      }

      return merchants;
    }, []);
  };

  useEffect(() => {
    if (selectedOption && oppMerchant?.ext_merchant_key !== selectedOption.uid) {
      updateOppMerchant(oppMerchant, {
        merchant_id: cloudStore.merchant.id,
        opp_master_merchant_id: oppMasterMerchant.id,
        ext_merchant_key: selectedOption.uid,
        name: selectedOption.name,
        partner_fee: partnerFee,
        locale: locale,
      }).then((oppMerchant) => {
        setOppMerchant(oppMerchant);
      });
    }
  }, [selectedOption]);

  useEffect(() => {
    let active = true;

    (async () => {
      const merchants = await searchAvailableOppMerchants(searchValue);
      if (active) {
        setOptions(merchants);
      }
    })();

    return () => {
      active = false;
    };
  }, [searchValue, availableOppMerchants]);

  React.useEffect(() => {
    if (!open) {
      setOptions([]);
    }
  }, [open]);

  if (!oppMasterMerchant && !oppMasterMerchants) {
    return (
      <div align="center">
        <CircularProgress color="primary" />
      </div>
    );
  }

  const selectOppMasterMerchantView = (
    <AuthorizationWrapper
      permission={"opp.connect_merchant"}
      child={
        <>
          <Paper style={{ width: "520px", padding: "16px", margin: "16px" }}>
            <Typography variant={"h6"}>Select OPP Key</Typography>
            <Grid>
              <Grid>
                <Select
                  value={oppMasterMerchant}
                  onChange={(e) => {
                    setOppMasterMerchant(e.target.value);
                  }}
                >
                  {oppMasterMerchants.map((oppMasterMerchant) => {
                    return <MenuItem value={oppMasterMerchant}>{oppMasterMerchant.name}</MenuItem>;
                  })}
                </Select>
              </Grid>
            </Grid>

            <Typography variant={"h6"}>Connect to other opp merchant</Typography>
            <Autocomplete
              style={{ width: 300 }}
              open={open}
              onOpen={() => {
                setOpen(true);
              }}
              onClose={() => {
                setOpen(false);
                setSearchValue("");
              }}
              filterOptions={(x) => x}
              onChange={(e, value) => {
                if (value) {
                  setSelectedOption(value);
                }
              }}
              onInputChange={(event, value) => {
                setSearchValue(value);
              }}
              getOptionSelected={(option, value) => {
                return option.uid === value.uid;
              }}
              getOptionLabel={(option) => option.uid + " - " + option.name}
              options={options}
              loading={loading}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={props.intl.formatMessage({ id: "Search" })}
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <React.Fragment>
                        {loading ? <CircularProgress color="inherit" size={20} /> : null}
                        {params.InputProps.endAdornment}
                      </React.Fragment>
                    ),
                  }}
                />
              )}
            />
          </Paper>
        </>
      }
    />
  );

  const selectOppMerchantView = (
    <Paper style={{ width: "520px", padding: "16px", margin: "16px" }}>
      <Typography variant={"h6"}>OPP merchant</Typography>

      {!oppMerchant && <Typography>No OPP merchant connected</Typography>}
      {oppMerchant && (
        <Grid container spacing={1} style={{ margin: 16 }} alignItems={"center"}>
          <Grid item xs={6}>
            Opp Merchant Name
          </Grid>
          <Grid item xs={6}>
            {oppMerchant.name}
          </Grid>
          <Grid item xs={6}>
            Opp Merchant Key
          </Grid>
          <Grid item xs={6}>
            {oppMerchant.ext_merchant_key}
          </Grid>
          <Grid item xs={6}>
            Partner Fee
          </Grid>
          <Grid item xs={6}>
            <EditPriceTextField
              price={oppMerchant.partner_fee}
              onBlur={(value, setBeginValue) => {
                updateOppMerchant(oppMerchant, { partner_fee: value }).then((oppMerchant) => {
                  setOppMerchant(oppMerchant);
                  setBeginValue(value);
                });
              }}
            />
          </Grid>
          <Grid item xs={6}>
            Language
          </Grid>
          <Grid item xs={6}>
            <Select
              value={locale}
              onChange={(e) => {
                updateOppMerchant(oppMerchant, { locale: e.target.value }).then((oppMerchant) => {
                  setOppMerchant(oppMerchant);
                  setLocale(e.target.value);
                });
              }}
            >
              {locales.map((loc) => {
                return <MenuItem value={loc}>{loc}</MenuItem>;
              })}
            </Select>
          </Grid>
        </Grid>
      )}
    </Paper>
  );

  return (
    <>
      {selectOppMasterMerchantView}
      {(availableOppMerchants || oppMerchant) && selectOppMerchantView}
    </>
  );
}

export default withIntl(Opp);
